/*
 * YAMIWARD — NIGHT PARADE MODE (百鬼夜行)
 * Between 19:00 and 05:59 visitor-local time the Ward transforms:
 * deeper palette, hitodama wisps, night service copy, elevated Summon odds
 * (server-side — see the Ward Board /api/summon). Loads BEFORE app.js so
 * window.YW_NIGHT is available to every other script.
 *
 * Preview overrides (session-scoped): ?parade=1 forces night, ?parade=0 forces day.
 */
(function () {
    'use strict';

    var OVERRIDE_KEY = 'yw_parade_override';

    try {
        var q = new URLSearchParams(window.location.search).get('parade');
        if (q === '1' || q === '0') sessionStorage.setItem(OVERRIDE_KEY, q);
    } catch (e) { /* sessionStorage unavailable — fall through to clock */ }

    function isNightNow() {
        try {
            var o = sessionStorage.getItem(OVERRIDE_KEY);
            if (o === '1') return true;
            if (o === '0') return false;
        } catch (e) { /* ignore */ }
        var h = new Date().getHours();
        return h >= 19 || h < 6;
    }

    // Ghost Line hours (Codex entry 007): 02:00–05:59 only.
    function isDeepNightNow() {
        var h = new Date().getHours();
        return h >= 2 && h < 6;
    }

    window.YW_NIGHT = isNightNow();
    window.YW_DEEP_NIGHT = window.YW_NIGHT && isDeepNightNow();
    if (window.YW_NIGHT) document.documentElement.classList.add('night-parade');

    var WISP_COLORS = ['#7FD9E8', '#7FD9E8', '#39FF6A', '#FFB347', '#B7A7F0'];
    var wispsHost = null;
    var banner = null;
    var summonNote = null;
    var savedReleaseTag = null;
    var savedBadgeText = null;

    function spawnWisps() {
        if (wispsHost) return;
        wispsHost = document.createElement('div');
        wispsHost.className = 'night-wisps';
        wispsHost.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < 7; i++) {
            var w = document.createElement('span');
            w.className = 'hitodama';
            w.style.setProperty('--wisp-color', WISP_COLORS[i % WISP_COLORS.length]);
            w.style.setProperty('--wisp-x', (4 + Math.random() * 92) + 'vw');
            w.style.setProperty('--wisp-dur', (38 + Math.random() * 44) + 's');
            w.style.setProperty('--wisp-delay', (-1 * Math.random() * 60) + 's');
            w.style.setProperty('--wisp-scale', (0.5 + Math.random() * 0.9).toFixed(2));
            wispsHost.appendChild(w);
        }
        document.body.appendChild(wispsHost);
    }

    function removeWisps() {
        if (wispsHost && wispsHost.parentNode) wispsHost.parentNode.removeChild(wispsHost);
        wispsHost = null;
    }

    function addBanner() {
        if (banner) return;
        var header = document.querySelector('.main-header');
        if (!header) return;
        banner = document.createElement('div');
        banner.className = 'night-banner';
        banner.innerHTML =
            '<span class="night-banner-moon">🌙</span>' +
            '<span class="night-banner-kanji">百鬼夜行</span>' +
            '<span class="night-banner-text">THE NIGHT PARADE IS PASSING · KAGE LINE IN SERVICE · SUMMON ODDS ELEVATED UNTIL DAWN</span>';
        header.insertAdjacentElement('afterend', banner);
    }

    function removeBanner() {
        if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
        banner = null;
    }

    function swapCopy(night) {
        var tag = document.querySelector('.release-tag');
        if (tag) {
            if (night) {
                if (savedReleaseTag === null) savedReleaseTag = tag.textContent;
                tag.textContent = '夜行 — NIGHT SERVICE ACTIVE · KAGE LINE RUNNING';
            } else if (savedReleaseTag !== null) {
                tag.textContent = savedReleaseTag;
            }
        }
        var badge = document.querySelector('.badge-status');
        if (badge) {
            // badge = glow span + text node; only touch the text node
            var textNode = null;
            for (var i = 0; i < badge.childNodes.length; i++) {
                if (badge.childNodes[i].nodeType === 3 && badge.childNodes[i].textContent.trim()) { textNode = badge.childNodes[i]; break; }
            }
            if (textNode) {
                if (night) {
                    if (savedBadgeText === null) savedBadgeText = textNode.textContent;
                    textNode.textContent = ' THE NIGHT PARADE IS PASSING ';
                } else if (savedBadgeText !== null) {
                    textNode.textContent = savedBadgeText;
                }
            }
        }
    }

    function addSummonNote(night) {
        var btn = document.getElementById('summon-btn');
        if (!btn) return;
        if (night && !summonNote) {
            summonNote = document.createElement('p');
            summonNote.className = 'night-summon-note';
            summonNote.textContent = '百鬼夜行 — the parade is passing. The spirits are restless: code odds elevated until dawn.';
            btn.insertAdjacentElement('afterend', summonNote);
        } else if (!night && summonNote) {
            if (summonNote.parentNode) summonNote.parentNode.removeChild(summonNote);
            summonNote = null;
        }
    }

    function apply() {
        var night = isNightNow();
        window.YW_NIGHT = night;
        window.YW_DEEP_NIGHT = night && isDeepNightNow();
        document.documentElement.classList.toggle('night-parade', night);
        if (night) { spawnWisps(); addBanner(); } else { removeWisps(); removeBanner(); }
        swapCopy(night);
        addSummonNote(night);
        document.dispatchEvent(new CustomEvent('yw:nightchange', { detail: { night: night } }));
    }

    function init() {
        apply();
        // Re-check each minute so the Ward turns while people browse.
        setInterval(apply, 60000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
